// Copyright (c) 2022 by Move Closer

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AvailableModuleDriver {
  Accordion = 'accordion',
  AdvertiseBox = 'advertise_box',
  ArticleHeader = 'article_header',
  ArticlesList = 'articles_list',
  ArticlesTeaser = 'articles_teaser',
  ArticlesTeaserBox = 'articles_teaser_box',
  ArtisticCarousel = 'artistic_carousel',
  Button = 'button',
  BenefitsBox = 'benefits_box',
  BrandTeaser = 'brand_teaser',
  Breadcrumbs = 'breadcrumbs',
  Card = 'card',
  CTABox = 'cta_box',
  ContactForm = 'contact_form',
  Creations = 'creations',
  DescriptionList = 'description_list',
  Footer = 'footer',
  Heading = 'heading',
  Hero = 'hero',
  Image = 'image',
  ImageList = 'image_list',
  Navbar = 'navbar',
  NavigationCTABox = 'navigation_cta_box',
  Newsletter = 'newsletter',
  ProductHeader = 'product_header',
  ProductReviews = 'product_reviews',
  ProductsList = 'products_list',
  ProductSpecification = 'product_specification',
  ProductsTeaser = 'products_teaser',
  ReviewsTeaser = 'reviews_teaser',
  Tabs = 'tabs',
  Text = 'text',
  Video = 'video',
  WhereToBuy = 'where_to_buy'
}
